<article [id]="data.slug+'-gallery'"
         class="w-full bg-black-alpha-10 py-6">
  <section class="w-full h-full bg-cover p-3 lg:p-6 relative flex flex-column justify-content-end">
    <swiper-container autoplay-delay="8000" class="w-full h-full">
      <swiper-slide *ngFor="let item of data.data.gallery">
        <section
          class="w-full h-full flex flex-column lg:flex-row gap-4 lg:gap-6 flex-row-reverse justify-content-center">
          <section class="w-full lg:w-5">
            <swiper-container autoplay-delay="3500" class="w-full h-full"
                              pagination="true" pagination-dynamic-bullets="true" pagination-clickable="true">
              <swiper-slide *ngFor="let photo of item.photos">
                <section class="w-full h-17rem md:h-25rem lg:h-28rem border-round-xl overflow-hidden bg-cover bg-no-repeat bg-center mb-5"
                         style="background: url({{photo}});">
                </section>
              </swiper-slide>
            </swiper-container>
          </section>

          <section class="w-full lg:w-5 flex flex-column justify-content-center gap-4">
            <section>
              <p *ngIf="item?.topic" class="ci-txt--grey text-lg mb-2">
                {{item.topic}}
              </p>

              <h3 *ngIf="item?.title" class="ci-txt--{{data.color}} text-2xl lg:text-4xl">
                {{item.title}}
              </h3>

              <h4 *ngIf="item?.subtitle" class="ci-txt--{{data.color}} text-xl lg:text-2xl">
                {{item.subtitle}}
              </h4>
            </section>

            <p class="ci-txt--black-lighten text-xl lg:text-2xl line-height-2 md:line-height-3 text-justify">
              {{item.description}}
            </p>
          </section>
        </section>
      </swiper-slide>
    </swiper-container>
  </section>
</article>